module.exports = __webpack_public_path__ + "img/9791160510911.e4637fbe.jpg";